import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

interface ToastProps {
  message: string;
  type: 'error' | 'success';
  onDismiss: () => void;
  autoDismissMs?: number;
}

const styles = {
  error: 'bg-red-500/10 border-red-500/30 text-red-400',
  success: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400',
};

export function Toast({ message, type, onDismiss, autoDismissMs = 5000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(timer);
  }, [onDismiss, autoDismissMs]);

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className={`border rounded-lg px-4 py-2.5 text-sm flex items-center justify-between gap-3 ${styles[type]}`}
          role="alert"
          aria-live="assertive"
        >
          <span>{message}</span>
          <button
            onClick={onDismiss}
            className="shrink-0 p-0.5 rounded hover:bg-white/10 transition-colors"
            aria-label="Dismiss notification"
          >
            <X size={14} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
